// extracted by mini-css-extract-plugin
export default {"error-handler__message":"ErrorHandler_error-handler__message__m47AR"};